import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { IEvidenceTypes } from '../Interfaces/IEvidenceTypes';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';

@Injectable({
	providedIn: 'root',
})
export class EvidenceTypesService extends RestCallService {
	public dataToSend: IEvidenceTypes = {
		pkevidencetype: 0,
		evidencetype: '',
		extensions: '',
		creationdate: new Date(),
		strcreationdate: '',
		fkemployeecreator: 1,
		lastupdated: new Date(),
		strlastupdated: '',
		fkemployeeupdater: 1,
		fkrecordstatus: 1,
		employeecreatorname: '',
		employeeupdatername: '',
		username: '',
    recordstatusname: '',
    fksite: 0
	};

	constructor(
		public httpClient: HttpClient,
    private cognitoService: CognitoService,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
	) {
		super(httpClient, 'JACSapi', toastr, notificationService, translate);
	}

	public GetList() {
		if (!this.cognitoService.IsAuhtenticated())
			this.cognitoService.LogOut();
		return this.get<IEvidenceTypes[]>(
			'/api/EvidenceTypes/GetEvidenceTypes',
		);
	}

	public GetEvidenceTypeByExtensionFile(data: string) {
		if (!this.cognitoService.IsAuhtenticated())
			this.cognitoService.LogOut();
		this.dataToSend.extensions = data;
		return this.post(
			'/api/EvidenceTypes/GetEvidenceTypeByExtensionFile',
			this.dataToSend,
		);
	}

	public CreateEvidenceType(data: any) {
		if (!this.cognitoService.IsAuhtenticated() && !this.cognitoService.GetUserInfo())
			this.cognitoService.LogOut();
		this.dataToSend.evidencetype = data.evidencetype;
		this.dataToSend.extensions = data.extensions;
    this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
		return this.post(
			'/api/EvidenceTypes/CreateEvidenceType',
			this.dataToSend,
		);
	}

	public UpdateEvidenceType(data: any) {
		if (!this.cognitoService.IsAuhtenticated() && !this.cognitoService.GetUserInfo())
			this.cognitoService.LogOut();
		this.dataToSend.pkevidencetype = data.pkevidencetype;
		this.dataToSend.evidencetype = data.evidencetype;
		this.dataToSend.extensions = data.extensions;
    this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
		return this.put(
			'/api/EvidenceTypes/UpdateEvidenceType',
			this.dataToSend,
		);
	}
	public DisableEvidenceType(data: any) {
		if (!this.cognitoService.IsAuhtenticated() && !this.cognitoService.GetUserInfo())
			this.cognitoService.LogOut();
		this.dataToSend.pkevidencetype = data.pkevidencetype;
    this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
		return this.put(
			'/api/EvidenceTypes/DisableEvidenceType',
			this.dataToSend,
		);
	}
	public AvailableEvidenceType(data: any) {
		if (!this.cognitoService.IsAuhtenticated() && !this.cognitoService.GetUserInfo())
			this.cognitoService.LogOut();
		this.dataToSend.pkevidencetype = data.pkevidencetype;
    this.dataToSend.fksite = Number(window.localStorage.getItem('pksite'));
		return this.put(
			'/api/EvidenceTypes/AvailableEvidenceType',
			this.dataToSend,
		);
	}
}
